import { ignore_dontShowAgainCheckbox } from 'owa-locstrings/lib/strings/ignore_dontshowagaincheckbox.locstring.json';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import { okButton } from 'owa-locstrings/lib/strings/okbutton.locstring.json';
import loc from 'owa-localize';
import { confirm, ConfirmCustomizationOptions, DialogResponse } from 'owa-confirm-dialog';

import * as React from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';

export default class IgnoreConversationsConfirmDialog {
    private isChecked: boolean;
    private title: string;
    private subtext: string;
    private onConfirm: (isChecked: boolean) => void;
    private onDismiss: () => void;
    private dialogOptions: ConfirmCustomizationOptions;

    constructor(
        title: string,
        subtext: string,
        onConfirm: (isChecked: boolean) => void,
        onDismiss: () => void
    ) {
        this.title = title;
        this.subtext = subtext;
        this.isChecked = false;
        this.onConfirm = onConfirm;
        this.onDismiss = onDismiss;

        this.dialogOptions = {
            okText: loc(okButton),
            cancelText: loc(cancelButton),
            bodyElement: (
                <Checkbox
                    label={loc(ignore_dontShowAgainCheckbox)}
                    onChange={this.checkboxToggled}
                />
            ),
        };
    }

    private checkboxToggled = () => {
        this.isChecked = !this.isChecked;
    };

    public show(): Promise<void> {
        return confirm(this.title, this.subtext, false, this.dialogOptions).then(
            (response: DialogResponse) => {
                if (response === DialogResponse.ok) {
                    return this.onConfirm(this.isChecked);
                } else {
                    return this.onDismiss();
                }
            }
        );
    }
}
